import { BarChart3 } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { AnalyticsView } from "./AnalyticsView";

export function SocialAnalyticsPage() {
  return (
    <div>
      <PageHeader
        icon={BarChart3}
        title="Social Analytics"
        description="Track post performance, follower growth, impressions, reach, and engagement rates across all your connected social accounts. Data refreshes every 24 hours."
      />
      <AnalyticsView showHeader={false} />
    </div>
  );
}
